import moment from 'moment';
import _ from 'lodash';

// extract keys, taking unique key or array of keys if multiple values are possible
export default function extractValueFromObject(object, key, type, defaultValue) {
  let value = defaultValue;
  let keys = [];
  if (typeof key === 'object') keys = [...key];
  else keys = [key];
  keys.forEach((k) => {
    let valueExtracted = _.get(object, k, null);
    if (valueExtracted) {
      switch (type) {
        case 'hexa':
          if (!(valueExtracted.length > 5 && valueExtracted.length < 8)) break;
          valueExtracted = parseInt(valueExtracted, 16);
          if (!Number.isNaN(valueExtracted)) value = valueExtracted;
          break;
        case 'date':
          value = moment(valueExtracted).format('YYYY-MM-DD');
          break;
        case 'dateFr':
          value = moment(valueExtracted).format('DD/MM/YYYY');
          break;
        case 'boolean':
          value = !![true, 'Y', 'yes', 'y', 'true'].includes(valueExtracted);
          break;
        case 'int':
          value = parseInt(valueExtracted, 10);
          break;
        default:
          value = valueExtracted;
          break;
      }
    }
  });
  return value;
}
